import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const sendEmptyMessageFromUser = async (chatId: string, token: string): Promise<AxiosResponse> =>
  AxiosInstance.post('livechat/message', {
    rid: chatId,
    token,
    msg: '',
  });
